import {
    SHOW_CREATE_PROJECT, HIDE_CREATE_PROJECT, SHOW_LOADER, SHOW_COPY_PROJECT, HIDE_COPY_PROJECT,
    SHOW_DEL_PROJECT, HIDE_DEL_PROJECT, HIDE_LOADER, SET_VIEW, SHOW_UPDATE_PROJ, HIDE_UPDATE_PROJ, SHOW_TAGS,
    FETCH_PACKAGE_START, FETCH_PACKAGE_SUCCESS, FETCH_PACKAGE_FAILURE, REFRESH_APP,
    ASSIGN_TAGS, RESET_UPDTAG, HIDE_TAGS, SHOW_PKGS, HIDE_PKGS, CREATE_PKG, HIDE_PKG, UPDATE_PKG, DESTROYED_GRID,
    FETCH_LOOKUP_START,
    FETCH_LOOKUP_SUCCESS,
    FETCH_LOOKUP_FAILURE,
    CHANGE_WS_TAB,
    CONF_ROUTING_CHECK_START,
    CONF_ROUTING_CHECK_SUCCESS,
    CONF_ROUTING_CHECK_FAILURE,
    GET_CONF_SESSIONID_START,
    GET_CONF_SESSIONID_SUCCESS,
    GET_CONF_SESSIONID_FAILURE,
    CONFIT_CREATE_QUOTE_START,
    CONFIT_CREATE_QUOTE_SUCCESS,
    CONFIT_CREATE_QUOTE_FAILURE,
    SET_CONF_INIT,
    CONFIT_UPDATE_QUOTE_START,
    CONFIT_UPDATE_QUOTE_SUCCESS,
    CONFIT_UPDATE_QUOTE_FAILURE
} from './ctrlTypes';


export const showCrProj = (payload) => (


    {

        type: SHOW_CREATE_PROJECT,
        payload,
    }
)

export const hideCrProj = (payload) => (
    // console.log(payload,"hiii"),
    {
        type: HIDE_CREATE_PROJECT,
        payload
    }
)

export const showLoader = (payload) => (
    {
        type: SHOW_LOADER,
        payload
    }
)

export const refreshApp = (payload) => (
    {
        type: REFRESH_APP,
        payload
    }
)
export const hideLoader = (payload) => (
    {
        type: HIDE_LOADER,
        payload
    }
)

export const setView = (payload) => (
    {
        type: SET_VIEW,
        payload
    }
)

export const showUpdProj = (payload) => (
    {
        type: SHOW_UPDATE_PROJ,
        payload
    }
)

export const hideUpdProj = (payload) => (
    {
        type: HIDE_UPDATE_PROJ,
        payload
    }
)


export const showCopyProj = (payload) => (
    {
        type: SHOW_COPY_PROJECT,
        payload,
    }
)

export const hideCOPYProj = (payload) => (
    {
        type: HIDE_COPY_PROJECT,
        payload
    }
)

export const showDelProj = (payload) => (
    {
        type: SHOW_DEL_PROJECT,
        payload,
    }
)

export const hideDelProj = (payload) => (
    {
        type: HIDE_DEL_PROJECT,
        payload
    }
)

export const showTags = (tPkg) => (
    {
        type: SHOW_TAGS,
        tPkg
    }
)

export const assignTags = (tags, colDefns) => (
    {
        type: ASSIGN_TAGS,
        tags,
        colDefns
    }
)

export const resetUpdTag = () => (
    {
        type: RESET_UPDTAG
    }
)

export const hideTags = () => (
    {
        type: HIDE_TAGS
    }
)

export const showPkgsAct = (payload) => (
    {
        type: SHOW_PKGS,
        payload
    }
)

export const hidePkgsAct = () => (
    {
        type: HIDE_PKGS
    }
)

export const crPkgAct = () => (
    {
        type: CREATE_PKG
    }
)

export const hidePkgAct = () => (
    {
        type: HIDE_PKG
    }
)

export const updPkgAct = (uPkg) => (
    {
        type: UPDATE_PKG,
        uPkg
    }
)

// NEW: Single action to trigger saga for all lookups
export const fetchLookupAct = (lookupNames) => ({
    type: FETCH_LOOKUP_START,
    lookupNames
});

export const destroyGrid = (payload) => (
    {
        type: DESTROYED_GRID,
        payload
    }
)

export const changeWSTab = (payload) => (
    {
        type: CHANGE_WS_TAB,
        payload
    }
)

export const confRoutingCheckAct = (payload) => ({
    type: CONF_ROUTING_CHECK_START,
    payload
});

export const confRoutingCheckSuccessAct = (rspData) => ({
    type: CONF_ROUTING_CHECK_SUCCESS,
    rspData
});

export const confRoutingCheckFailureAct = (payload) => ({
    type: CONF_ROUTING_CHECK_FAILURE,
    payload
});


export const getConfSessionIDAct = (payload) => ({
    type: GET_CONF_SESSIONID_START,
    payload
});

export const getConfSessionIDSuccessAct = (rspData) => ({
    type: GET_CONF_SESSIONID_SUCCESS,
    rspData
});

export const getConfSessionIDFailureAct = (payload) => ({
    type: GET_CONF_SESSIONID_FAILURE,
    payload
});

export const confCreateQuoteAct = (payload) => ({
    type: CONFIT_CREATE_QUOTE_START,
    payload
});

export const confCreateQuoteSuccessAct = (rspData) => ({
    type: CONFIT_CREATE_QUOTE_SUCCESS,
    rspData
});

export const confCreateQuoteFailureAct = (payload) => ({
    type: CONFIT_CREATE_QUOTE_FAILURE,
    payload
});

export const confUpdateQuoteAct = (payload) => ({
    type: CONFIT_UPDATE_QUOTE_START,
    payload
});

export const confUpdateQuoteSuccessAct = (rspData) => ({
    type: CONFIT_UPDATE_QUOTE_SUCCESS,
    rspData
});

export const confUpdateQuoteFailureAct = (payload) => ({
    type: CONFIT_UPDATE_QUOTE_FAILURE,
    payload
});
export const setConfInitAct = () => ({
    type: SET_CONF_INIT,
});

